import { Inject, Injectable } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { from, defer } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbOnlineStatusService {
  isOnline$ = defer(() =>
    from(
      new Promise<boolean>((resolve, reject) => {
        fetch(`${this.appConfig.networkCheckFallbackUrl}?t=${Date.now()}`)
          .then(() => resolve(true))
          .catch(() => resolve(false))
      }),
    ),
  )

  constructor(@Inject(APP_CONFIG) protected appConfig: any) {}
}
